import { render, staticRenderFns } from "./AlternativeNameForm.vue?vue&type=template&id=7f46a814&scoped=true"
import script from "./AlternativeNameForm.vue?vue&type=script&lang=js"
export * from "./AlternativeNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46a814",
  null
  
)

export default component.exports